var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.7778,
    height: 41.7778,
    rx: 20,
    fill: "#6EE796"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35193 20.889C4.35193 13.0933 4.35193 9.19552 6.77372 6.77372C9.19552 4.35193 13.0933 4.35193 20.889 4.35193C28.6845 4.35193 32.5824 4.35193 35.0043 6.77372C37.426 9.19552 37.426 13.0933 37.426 20.889C37.426 28.6845 37.426 32.5824 35.0043 35.0043C32.5824 37.426 28.6845 37.426 20.889 37.426C13.0933 37.426 9.19552 37.426 6.77372 35.0043C4.35193 32.5824 4.35193 28.6845 4.35193 20.889Z",
    stroke: "black",
    strokeWidth: 2.61111,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3403 19.1612C16.9128 18.9594 13.659 19.2933 12.0636 22.2435C10.4681 25.1935 12.0761 28.264 13.0795 29.4305C14.0704 30.5218 17.2199 32.5884 20.5606 30.5707C21.3887 30.0706 22.4203 29.6975 23.5906 25.7896L23.4544 10.4121C23.2287 12.1054 25.0991 16.077 30.4247 16.5469",
    stroke: "black",
    strokeWidth: 2.61111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.a1e5715823fe210cafa4529c85a86fd1.svg";
export { ForwardRef as ReactComponent };